import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { useIsAIEnabledForContentQuery } from '../../hooks/useIsAIEnabledForContent';

export function preloadUseIsAIEnabledForContentQuery(contentId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: useIsAIEnabledForContentQuery,
		variables: {
			contentId,
		},
	});
}
